import React, { useState, useRef, useEffect } from 'react';
import { X, Send } from 'lucide-react';

// ═══ SVG іконка порадника — чат-бульбашка з AI ═══
export const AdvisorIcon = ({ size = 18, strokeColor = '#fff', aiColor = '#f97316' }) => (
  <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={strokeColor} strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round">
    <path d="M12 2C6.48 2 2 5.58 2 10c0 2.48 1.51 4.68 3.85 6.15L4.5 21l4.28-2.14C9.8 19.28 10.88 19.5 12 19.5c5.52 0 10-3.58 10-8S17.52 2 12 2z"/>
    <text x="12" y="11.5" textAnchor="middle" dominantBaseline="middle" fill={aiColor} stroke="none" fontSize="7" fontWeight="800" fontFamily="Roboto,sans-serif">AI</text>
  </svg>
);

// ═══ Модалка-оголошення (одноразова) ═══
export const AdvisorAnnouncement = ({ onClose, onTry }) => {
  return (
    <div
      style={{ position: 'fixed', inset: 0, backgroundColor: 'rgba(0,0,0,0.5)', display: 'flex', alignItems: 'center', justifyContent: 'center', zIndex: 1100, padding: 16 }}
      onClick={(e) => { if (e.target === e.currentTarget) onClose(); }}
    >
      <div style={{ backgroundColor: '#fff', borderRadius: 20, maxWidth: 400, width: '100%', overflow: 'hidden', boxShadow: '0 25px 60px rgba(0,0,0,0.2)', animation: 'advisorSlideUp .35s ease' }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #163248 0%, #1e4a6e 100%)', padding: '32px 28px 28px', textAlign: 'center' }}>
          <span style={{ display: 'inline-block', background: '#f97316', color: '#fff', fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 10, letterSpacing: 0.5, marginBottom: 10 }}>НОВЕ</span>
          <div style={{ width: 72, height: 72, borderRadius: '50%', background: 'rgba(249,115,22,0.15)', display: 'flex', alignItems: 'center', justifyContent: 'center', margin: '0 auto 16px' }}>
            <AdvisorIcon size={36} aiColor="#f97316" />
          </div>
          <h2 style={{ color: '#fff', fontSize: 22, fontWeight: 700, marginBottom: 6, fontFamily: "'Roboto', sans-serif" }}>Порадник LIHTAR</h2>
          <p style={{ color: '#c8dde6', fontSize: 14, lineHeight: 1.6, margin: 0 }}>Ваш AI-помічник по всіх функціях платформи. Запитайте будь-що — як створити кошторис, де знайти калькулятор, як працюють тендери.</p>
        </div>

        {/* Body */}
        <div style={{ padding: '24px 28px' }}>
          {/* Features */}
          <div style={{ display: 'flex', flexDirection: 'column', gap: 14, marginBottom: 24 }}>
            {[
              { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#163248" strokeWidth="2"><circle cx="11" cy="11" r="8"/><path d="M21 21l-4.35-4.35"/></svg>, title: 'Миттєві відповіді', desc: 'Як створити шаблон? Де подивитись баланс? — відповідь за секунди' },
              { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#163248" strokeWidth="2"><path d="M14 2H6a2 2 0 0 0-2 2v16a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2V8z"/><path d="M14 2v6h6"/><path d="M16 13H8"/><path d="M16 17H8"/><path d="M10 9H8"/></svg>, title: 'Покрокові інструкції', desc: 'Детальні пояснення для кожної функції платформи' },
              { icon: <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="#163248" strokeWidth="2"><path d="M22 11.08V12a10 10 0 1 1-5.93-9.14"/><path d="M22 4L12 14.01l-3-3"/></svg>, title: 'Завжди під рукою', desc: 'Доступний на кожному екрані — не потрібно шукати' },
            ].map((f, i) => (
              <div key={i} style={{ display: 'flex', alignItems: 'flex-start', gap: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: '#f0f4f8', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>{f.icon}</div>
                <div>
                  <div style={{ fontSize: 14, fontWeight: 600, color: '#163248', marginBottom: 2 }}>{f.title}</div>
                  <div style={{ fontSize: 12, color: '#6b7280', lineHeight: 1.4 }}>{f.desc}</div>
                </div>
              </div>
            ))}
          </div>

          {/* Where to find */}
          <div style={{ background: '#f8fafc', borderRadius: 12, padding: '14px 16px', display: 'flex', alignItems: 'center', gap: 12, marginBottom: 20 }}>
            <div style={{ width: 40, height: 40, borderRadius: '50%', background: 'linear-gradient(135deg, #163248, #1e4a6e)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
              <AdvisorIcon size={20} aiColor="#f97316" />
            </div>
            <div style={{ fontSize: 13, color: '#374151', lineHeight: 1.5 }}>
              Шукайте <strong style={{ color: '#163248' }}>кнопку внизу справа</strong> на головній або <strong style={{ color: '#163248' }}>іконку в шапці</strong> кошторису
            </div>
          </div>

          {/* Actions */}
          <div style={{ display: 'flex', gap: 12 }}>
            <button
              onClick={onClose}
              style={{ padding: '14px 20px', borderRadius: 12, border: '1.5px solid #e5e7eb', background: '#fff', color: '#6b7280', fontWeight: 600, fontSize: 14, cursor: 'pointer', fontFamily: 'inherit' }}
            >
              Закрити
            </button>
            <button
              onClick={() => { onClose(); onTry(); }}
              style={{ flex: 1, padding: 14, borderRadius: 12, border: 'none', background: '#f97316', color: '#fff', fontWeight: 700, fontSize: 15, cursor: 'pointer', fontFamily: 'inherit', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: 8 }}
            >
              <AdvisorIcon size={18} strokeColor="#fff" aiColor="#fff" />
              Спробувати
            </button>
          </div>
        </div>
      </div>
      <style>{`@keyframes advisorSlideUp{from{opacity:0;transform:translateY(24px)}to{opacity:1;transform:translateY(0)}}`}</style>
    </div>
  );
};

// ═══ Вікно чату ═══
export const AdvisorChat = ({ isOpen, onClose }) => {
  const [messages, setMessages] = useState([
    { id: 1, role: 'bot', text: 'Привіт! Я Порадник LIHTAR 👋 Запитайте мене про будь-яку функцію платформи — допоможу розібратися.' }
  ]);
  const [input, setInput] = useState('');
  const [loading, setLoading] = useState(false);
  const messagesEndRef = useRef(null);
  const inputRef = useRef(null);
  const isMob = typeof window !== 'undefined' && window.innerWidth < 640;

  useEffect(() => {
    if (isOpen) {
      setTimeout(() => inputRef.current?.focus(), 300);
      document.body.style.overflow = 'hidden';
      return () => { document.body.style.overflow = ''; };
    }
  }, [isOpen]);

  useEffect(() => {
    messagesEndRef.current?.scrollIntoView({ behavior: 'smooth' });
  }, [messages]);

  const handleSend = async () => {
    const text = input.trim();
    if (!text || loading) return;
    const userMsg = { id: Date.now(), role: 'user', text };
    setMessages(prev => [...prev, userMsg]);
    setInput('');
    setLoading(true);
    try {
      // Формуємо історію для контексту (без першого привітання бота)
      const history = messages
        .filter(m => m.id !== 1)
        .map(m => ({ role: m.role === 'bot' ? 'assistant' : 'user', content: m.text }));

      const res = await fetch(
        'https://jkouufahpliqgyvcmbwb.supabase.co/functions/v1/advisor-chat',
        {
          method: 'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ message: text, history }),
        }
      );
      const data = await res.json();
      if (data.text) {
        setMessages(prev => [...prev, { id: Date.now() + 1, role: 'bot', text: data.text }]);
      } else {
        setMessages(prev => [...prev, { id: Date.now() + 1, role: 'bot', text: data.error || 'Помилка. Спробуйте ще раз.' }]);
      }
    } catch (err) {
      setMessages(prev => [...prev, { id: Date.now() + 1, role: 'bot', text: 'Помилка зʼєднання. Перевірте інтернет і спробуйте ще раз.' }]);
    }
    setLoading(false);
  };

  const quickActions = [
    'Як працює AI-імпорт?',
    'Що входить в PRO?',
    'Як поділитись з клієнтом?',
  ];

  if (!isOpen) return null;

  return (
    <>
      {/* Overlay for mobile */}
      {isMob && <div style={{ position: 'fixed', inset: 0, background: 'rgba(0,0,0,0.3)', zIndex: 1049 }} onClick={onClose} />}
      <div style={{
        position: 'fixed',
        bottom: isMob ? 0 : 92,
        right: isMob ? 0 : 24,
        left: isMob ? 0 : 'auto',
        zIndex: 1050,
        width: isMob ? '100%' : 380,
        maxHeight: isMob ? '85vh' : 520,
        background: '#fff',
        borderRadius: isMob ? '20px 20px 0 0' : 20,
        boxShadow: '0 12px 48px rgba(0,0,0,0.18)',
        display: 'flex', flexDirection: 'column',
        overflow: 'hidden',
        animation: 'advisorChatIn .3s ease',
      }}>
        {/* Header */}
        <div style={{ background: 'linear-gradient(135deg, #163248 0%, #1e4a6e 100%)', padding: '16px 20px', display: 'flex', alignItems: 'center', gap: 12, flexShrink: 0 }}>
          <div style={{ width: 38, height: 38, borderRadius: '50%', background: 'rgba(249,115,22,0.2)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
            <AdvisorIcon size={20} aiColor="#f97316" />
          </div>
          <div style={{ flex: 1 }}>
            <h3 style={{ color: '#fff', fontSize: 15, fontWeight: 600, margin: 0 }}>Порадник LIHTAR</h3>
            <p style={{ color: '#90b4c8', fontSize: 11, margin: 0 }}>Запитайте будь-що про платформу</p>
          </div>
          <button onClick={onClose} style={{ width: 30, height: 30, borderRadius: '50%', background: 'rgba(255,255,255,0.12)', border: 'none', cursor: 'pointer', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
            <X size={14} color="#fff" />
          </button>
        </div>

        {/* Messages */}
        <div style={{ flex: 1, overflowY: 'auto', padding: '16px 16px 8px', display: 'flex', flexDirection: 'column', gap: 12, background: '#f8fafc', minHeight: isMob ? 200 : 280, overscrollBehavior: 'contain' }}>
          {messages.map(msg => (
            <div key={msg.id} style={{ alignSelf: msg.role === 'user' ? 'flex-end' : 'flex-start', maxWidth: '85%' }}>
              {msg.role === 'bot' && (
                <div style={{ display: 'flex', alignItems: 'flex-end', gap: 8 }}>
                  <div style={{ width: 24, height: 24, borderRadius: '50%', background: 'linear-gradient(135deg, #163248, #1e4a6e)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                    <AdvisorIcon size={12} aiColor="#f97316" />
                  </div>
                  <div style={{ padding: '10px 14px', borderRadius: '16px 16px 16px 4px', background: '#fff', border: '1px solid #e5e7eb', fontSize: 14, lineHeight: 1.5, color: '#374151' }}>{msg.text}</div>
                </div>
              )}
              {msg.role === 'user' && (
                <div style={{ padding: '10px 14px', borderRadius: '16px 16px 4px 16px', background: '#163248', color: '#fff', fontSize: 14, lineHeight: 1.5 }}>{msg.text}</div>
              )}
            </div>
          ))}
          {loading && (
            <div style={{ alignSelf: 'flex-start', display: 'flex', alignItems: 'flex-end', gap: 8 }}>
              <div style={{ width: 24, height: 24, borderRadius: '50%', background: 'linear-gradient(135deg, #163248, #1e4a6e)', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0 }}>
                <AdvisorIcon size={12} aiColor="#f97316" />
              </div>
              <div style={{ padding: '10px 14px', borderRadius: '16px 16px 16px 4px', background: '#fff', border: '1px solid #e5e7eb', fontSize: 14, color: '#9ca3af' }}>
                <span className="animate-pulse">Думаю...</span>
              </div>
            </div>
          )}
          <div ref={messagesEndRef} />
        </div>

        {/* Quick actions */}
        {messages.length <= 1 && (
          <div style={{ padding: '0 16px 12px', display: 'flex', gap: 6, flexWrap: 'wrap', background: '#f8fafc' }}>
            {quickActions.map((q, i) => (
              <button key={i} onClick={() => { setInput(q); }}
                style={{ padding: '6px 12px', borderRadius: 20, border: '1px solid #e5e7eb', background: '#fff', fontSize: 12, color: '#163248', cursor: 'pointer', fontFamily: 'inherit', fontWeight: 500 }}
              >{q}</button>
            ))}
          </div>
        )}

        {/* Input */}
        <div style={{ padding: '12px 16px', borderTop: '1px solid #f0f0f0', display: 'flex', alignItems: 'center', gap: 8, background: '#fff', flexShrink: 0 }}>
          <input
            ref={inputRef}
            type="text"
            value={input}
            onChange={(e) => setInput(e.target.value)}
            onKeyDown={(e) => { if (e.key === 'Enter' && !e.shiftKey) { e.preventDefault(); handleSend(); } }}
            placeholder="Запитайте будь-що..."
            style={{ flex: 1, border: '1.5px solid #e5e7eb', borderRadius: 12, padding: '10px 14px', fontSize: 14, fontFamily: 'inherit', outline: 'none', background: '#fafafa' }}
            onFocus={(e) => { e.target.style.borderColor = '#163248'; e.target.style.background = '#fff'; }}
            onBlur={(e) => { e.target.style.borderColor = '#e5e7eb'; e.target.style.background = '#fafafa'; }}
          />
          <button
            onClick={handleSend}
            disabled={!input.trim() || loading}
            style={{ width: 40, height: 40, borderRadius: 12, background: input.trim() ? '#163248' : '#e5e7eb', border: 'none', cursor: input.trim() ? 'pointer' : 'default', display: 'flex', alignItems: 'center', justifyContent: 'center', flexShrink: 0, transition: 'background .15s' }}
          >
            <Send size={16} color="#fff" />
          </button>
        </div>
      </div>
      <style>{`@keyframes advisorChatIn{from{opacity:0;transform:translateY(16px) scale(.96)}to{opacity:1;transform:translateY(0) scale(1)}}`}</style>
    </>
  );
};

// ═══ FAB кнопка ═══
export const AdvisorFAB = ({ onClick, hasNotification = false }) => {
  return (
    <button
      onClick={onClick}
      title="Порадник LIHTAR"
      style={{
        position: 'fixed', bottom: 24, right: 24, zIndex: 900,
        width: 56, height: 56, borderRadius: '50%',
        background: 'linear-gradient(135deg, #163248 0%, #1e4a6e 100%)',
        border: 'none', cursor: 'pointer',
        display: 'flex', alignItems: 'center', justifyContent: 'center',
        boxShadow: '0 4px 20px rgba(22,50,72,0.35)',
        transition: 'transform 0.2s, box-shadow 0.2s',
      }}
      onMouseEnter={(e) => { e.currentTarget.style.transform = 'scale(1.08)'; e.currentTarget.style.boxShadow = '0 6px 28px rgba(22,50,72,0.45)'; }}
      onMouseLeave={(e) => { e.currentTarget.style.transform = 'scale(1)'; e.currentTarget.style.boxShadow = '0 4px 20px rgba(22,50,72,0.35)'; }}
      className="advisor-fab"
    >
      <AdvisorIcon size={30} aiColor="#f97316" />
      {hasNotification && (
        <span style={{ position: 'absolute', top: -2, right: -2, width: 14, height: 14, background: '#f97316', borderRadius: '50%', border: '2px solid #fff' }} />
      )}
      <style>{`
        @keyframes advisorPulse { 0%, 100% { box-shadow: 0 4px 20px rgba(22,50,72,0.35); } 50% { box-shadow: 0 4px 20px rgba(22,50,72,0.35), 0 0 0 8px rgba(22,50,72,0.08); } }
        .advisor-fab { animation: advisorPulse 3s ease-in-out infinite; }
        @media (max-width: 640px) { .advisor-fab { bottom: 140px !important; right: 16px !important; width: 50px !important; height: 50px !important; } }
      `}</style>
    </button>
  );
};

// ═══ Header кнопка (для EstimateScreen) ═══
export const AdvisorHeaderButton = ({ onClick }) => {
  return (
    <button
      onClick={onClick}
      className="flex items-center justify-center w-9 h-9 rounded-full bg-white shadow-sm hover:shadow-md border border-gray-100 transition-all"
      title="Порадник LIHTAR"
    >
      <AdvisorIcon size={16} strokeColor="#163248" aiColor="#f97316" />
    </button>
  );
};

export default { AdvisorIcon, AdvisorAnnouncement, AdvisorChat, AdvisorFAB, AdvisorHeaderButton };
